import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';
import type { FC, ReactNode } from 'react';
import { socialLinks } from '../../data/social-links';

const iconByLabel: Record<string, ReactNode> = {
  Instagram: <Instagram size={18} strokeWidth={1.75} />,
  YouTube: <Youtube size={18} strokeWidth={1.75} />,
  LinkedIn: <Linkedin size={18} strokeWidth={1.75} />,
  Facebook: <Facebook size={18} strokeWidth={1.75} />,
};

const TopBar: FC = () => (
  <div className="site-header__top-bar">
    <div className="site-header__container site-header__top-bar-inner">
      <p className="site-header__tagline hidden md:block">
        Precision Engineering Since 1965
      </p>
      <div
        aria-label="Social media"
        className="site-header__social"
        role="navigation"
      >
        {socialLinks.map(({ label, href }) => (
          <a
            aria-label={label}
            className="site-header__social-link"
            href={href}
            key={label}
            rel="noopener noreferrer"
            target="_blank"
          >
            {iconByLabel[label]}
          </a>
        ))}
      </div>
    </div>
  </div>
);

export default TopBar;
